import React, {useState, Fragment, useContext, createContext} from "react";
import {Fade, Modal} from "@mui/material";
import {Svg} from "assets";

export const DetailModalContext = createContext(null);

export const DetailModalProvider = ({children}) => {
    const [params, setParams] = useState({});
    const [modalInfo, setModalInfo] = useState({});

    return (
        <Fragment>
            <DetailModalContext.Provider
                value={{
                    params,
                    setParams,
                    modalInfo,
                    setModalInfo,
                }}
            >
                {children}
            </DetailModalContext.Provider>
        </Fragment>
    );
};

export const useDetailModal = () => {
    const {params, setParams, modalInfo, setModalInfo} =
        useContext(DetailModalContext);

    return {
        openDetail: (params = {}, modalInfo) => {
            setParams(params);
            setModalInfo(modalInfo);
        },
        closeDetail: () => {
            setParams({});
            setModalInfo({});
        },
        params,
        modalInfo,
    };
};

export const DetailModal = () => {
    const {closeDetail, params, modalInfo} = useDetailModal();
    const renderOpen = Object.keys(params).length !== 0;

    return (
        renderOpen && (
            <Modal
                style={{zIndex: "1400"}}
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={renderOpen}
                onClose={() => {
                    if (!modalInfo?.dontClose) {
                        closeDetail()
                    }
                }}
                closeAfterTransition
                hideBackdrop={false}
            >
                <Fade in={renderOpen}>
                    <div
                        style={
                            {
                                padding: modalInfo?.padding === "noPaddings" ? 0 : '',
                                outline: modalInfo?.padding === "noPaddings" ? 'none' : 'none',
                                maxWidth: modalInfo?.maxWidth ? modalInfo?.maxWidth : 'inherit',
                                ...modalInfo?.styles
                            }
                        }
                        className={`modal-wrapper ${
                            modalInfo?.className ? modalInfo?.className : ""
                        }`}
                    >
                        {!modalInfo?.noShowCloseBtn && (
                            <div className="modal-header-style">
                                <button
                                    type="button"
                                    className="close-modal-btn"
                                    onClick={() => closeDetail()}
                                >
                                    <Svg.CloseSvg/>
                                </button>
                            </div>
                        )}
                        {params}
                    </div>
                </Fade>
            </Modal>
        )
    );
};
